export const defaultConfiguration = {
  showDownloadIcon: true,
  showPrintIcon: true,
}